import $ from 'jquery';
import EFOcats_import_html from '../import/efocats_import_html';
import EFOcats_event_core from './efocats_event_core';

/**
 * 他の入力欄の回答によって選択肢が変更される入力欄の選択肢更新処理
 */
export default class EFOcats_event_interlock_option extends EFOcats_event_core {
  /**
   * 初期設定
   * @param {*} srcName 選択肢が更新されるきっかけとなる入力欄のname属性
   * @param {*} destName 更新する入力欄のname属性
   * @param {*} interval 選択肢更新までの間隔(ms)
   */
  constructor(srcName, destName, interval = 100) {
    super();

    this.srcName = srcName;
    this.destName = destName;
    this.interval = interval;
  }

  /**
   * イベント
   */
  event() {
    // きっかけとなる入力欄の値が変更された
    this.$(`[name="${this.srcName}"]`).on('change', event => {
      // 元フォームに反映
      $(`[name="${this.srcName}"]`).val(this.$(`[name="${this.srcName}"]`).val());

      // 変更イベントを発生させる
      this.triggerEvent();

      // 一拍置いてから選択肢をEFOcatsに反映する
      setTimeout(() => this.updateOptions(), this.interval);
    });
  }

  updateOptions() {
    const options = $(`select[name="${this.destName}"]`).children();
    this.$(`select[name="${this.destName}"]`).empty();

    for (let index = 0; index < options.length; index++) {
      const option = options.eq(index);

      if (option.prop('tagName').toLowerCase() === 'optgroup') {
        const group = this.$(`select[name="${this.destName}"]`).append(EFOcats_import_html.getValue('select-opt-group', {label: option.attr('label')}));
        const suboptions = option.children();

        for (let subindex = 0; subindex < suboptions.length; subindex++) {
          const suboption = suboptions.eq(subindex);
          group.append(EFOcats_import_html.getValue('select-question-option', {val: suboption.val(), text: suboption.text()}));
        }
      } else {
        this.$(`select[name="${this.destName}"]`).append(EFOcats_import_html.getValue('select-question-option', {val: option.val(), text: option.text()}));
      }
    }

    this.$(`select[name="${this.destName}"]`).val($(`select[name="${this.destName}"]`).val());

    efocats.validations.check_error(this.$(`select[name="${this.destName}"]`), false);
  }

  /**
   * 元フォームのイベントを起動する
   */
  triggerEvent() {
    let changeEvent;

    const ua = window.navigator.userAgent.toLowerCase();

    if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) {
      changeEvent = document.createEvent('Event');
      changeEvent.initEvent('change', true, true);
    } else {
      changeEvent = new Event('change', {bubbles: true, cancelable: true});
    }

    $(`[name="${this.srcName}"]`).get(0).dispatchEvent(changeEvent);
  }
}
